import { styled } from '@bob/library'

export const Wrapper = styled.div`
  padding: 40px 0;
`
